import { del, get, post, put } from "helpers/api_helper/Authentication/authenticationApiHelper"

export const getDynamicData= url => get(url.DYNAMIC_DEFINITIONS)
export const addNewDynamicData = (url, dynamicData) => post(url.DYNAMIC_DEFINITIONS, dynamicData)
export const updateDynamicData = (url, dynamicData) => put(`${url.DYNAMIC_DEFINITIONS}`, dynamicData)
export const deleteDynamicData = (url, guid) => del(`${url.DYNAMIC_DEFINITIONS}/${guid}`, { params: { guid } })


